import { render, staticRenderFns } from "./TTsViewHome.vue?vue&type=template&id=10babb16&"
import script from "./TTsViewHome.vue?vue&type=script&lang=js&"
export * from "./TTsViewHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports